export const APP_CACHE_STORAGE_DRIVER = 'localStorage'; // 'sesionStorage' | 'localStorage'
export const AUTH_PROVIDER = 'firebase';
export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_ENDPOINT;
export const REACT_APP_FIREBASE_STORAGE_BASE_URL = process.env.REACT_APP_FIREBASE_STORAGE_BASE_URL
  || 'https://firebasestorage.googleapis.com/v0/b/post-fashion.appspot.com/o';
export default {
  offline: {
    enabled: false,
  },
  app: {
    isProduction: process.env.NODE_ENV === 'production',
  },
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  },
};
